import React, { useState } from "react";
import { dateFormation } from "../../common/cores";
import { isMobile } from "../../utils/utils";

const TitleBox = (props) => {
  return (
    <div className="title_wrap" style={{ paddingTop: isMobile() && "10px" }}>
      <div className="title_box">
        <div className="title">{props.title}</div>
      </div>
    </div>
  );
};

export default TitleBox;



// WEBPACK FOOTER //
// ./src/components/common/TitleBox.js